import React from 'react';

import SearchBar from '@components/pages/Organization/UsersSection/UserTypes/SearchBar';

import useOrgChart from '../OrgChartContext';
import EmployeeSearchItem from './EmployeeSearchItem';
import { OrgChartSearchProps } from './interfaces';
import { useOrgChartSearch } from './useOrgChartSearch';

const OrgChartSearch: React.FC<OrgChartSearchProps> = ({
  placeholder = 'Search for an employee',
  onSearchTermChange,
  maxResults = 5,
}) => {
  const { employees } = useOrgChart();

  const {
    searchTerm,
    searchResults,
    isDropdownOpen,
    highlightedIndex,
    dropdownRef,
    resultsContainerRef,
    handleSearchTermChange,
    handleKeyDown,
    handleSelectPath,
    getResultIndex,
    getItemKey,
    registerItemRef,
    setHighlightedIndex,
  } = useOrgChartSearch({
    onSearchTermChange,
    maxResults,
  });

  const handleMouseLeave = () => {
    setHighlightedIndex(-1);
  };

  return (
    <div className="relative" ref={dropdownRef} onKeyDown={handleKeyDown} tabIndex={-1}>
      <SearchBar
        searchTerm={searchTerm}
        setSearchTerm={handleSearchTermChange}
        placeholder={placeholder}
      />

      {isDropdownOpen && searchResults.length > 0 && (
        <div className="mt-1 rounded-md shadow-lg absolute z-50 w-full bg-white">
          <div
            ref={resultsContainerRef}
            className="py-1 max-h-[300px] overflow-auto border border-solid border-grayscale-beige"
            onMouseLeave={handleMouseLeave}
          >
            {searchResults.map((result) => (
              <div key={result.employee.id}>
                {result.paths.map((pathInfo) => {
                  const resultIndex = getResultIndex(result.employee.id, pathInfo.path);
                  const isHighlighted = resultIndex === highlightedIndex;
                  const itemKey = getItemKey(result.employee.id, pathInfo.path);

                  return (
                    <EmployeeSearchItem
                      key={itemKey}
                      ref={(el) => registerItemRef(result.employee.id, pathInfo.path, el)}
                      employee={result.employee}
                      reportsToId={pathInfo.reportsTo}
                      allEmployees={employees}
                      onSelectPath={() => handleSelectPath(result.employee.id, pathInfo.path)}
                      isHighlighted={isHighlighted}
                      onMouseEnter={() => setHighlightedIndex(resultIndex)}
                      path={pathInfo.path}
                    />
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrgChartSearch;
